import { Client, ClientAddress } from "@/api";

interface ClientAddressLinesProps {
  client: Client;
}
export default function ClientAddressLines({
  client,
}: ClientAddressLinesProps) {
  const keys: (keyof ClientAddress)[] = [
    "street",
    "zipcode",
    "city",
    "country",
  ];
  const parts = keys
    .map((k) => {
      if (k === "country" && client.address_json?.[k] === "NL") {
        return null;
      }
      return client.address_json?.[k];
    })
    .filter((v) => !!v);

  if (client.name) {
    parts.unshift(client.name);
  }

  return (
    <div className="client-address-lines">
      {parts.map((part, index) => (
        <div key={index}>{part}</div>
      ))}
    </div>
  );
}
